import { render, staticRenderFns } from "./editgrouper.vue?vue&type=template&id=7c184ff0&"
import script from "./editgrouper.vue?vue&type=script&lang=js&"
export * from "./editgrouper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports